import React from 'react';
import { classNames } from 'primereact/utils';
import { ChildContainerProps } from '../../types';
import { Menubar } from 'primereact/menubar';
import './layout.module.css';
import { useAppSelector } from 'app/config/store';
import { useNavigate } from 'react-router-dom';

const ClientLayout = (props: ChildContainerProps) => {
  const navigate = useNavigate();
  const account = useAppSelector(state => state.authentication.account);

  const itemRenderer = (item, url) => (
    <a className="flex align-items-center p-menuitem-link" onClick={() => navigate(url)}>
      <span className={item.icon} />
      <span className="mx-2">{item.label}</span>
    </a>
  );

  const showBanner = window.location.pathname !== '/change-password';

  const menuItems = [
    {
      label: 'ÚVOD',
      className: window.location.pathname === '/' ? 'active-menu-item' : '',
      command: () => navigate('/'),
    },
    {
      label: 'MOJE ZMLUVY',
      className: window.location.pathname === '/contracts' ? 'active-menu-item' : '',
      command: () => navigate('/contracts'),
    },
    {
      label: 'ŽIADOSTI',
      className: window.location.pathname === '/requests' || window.location.pathname === '/requests/new' ? 'active-menu-item' : '',
      items: [
        {
          label: 'Nová žiadosť',
          template: i => itemRenderer(i, '/requests/new'),
        },
        {
          label: 'Odoslané žiadosti',
          template: i => itemRenderer(i, '/requests'),
        },
      ],
    },
    {
      label: 'INFORMÁCIE',
      className: window.location.pathname === '/conditions' || window.location.pathname === '/personal-data' ? 'active-menu-item' : '',
      items: [
        {
          label: 'Podmienky používania',
          template: i => itemRenderer(i, '/conditions'),
        },
        {
          label: 'Spracovanie osobných údajov',
          template: i => itemRenderer(i, '/personal-data'),
        },
      ],
    },
    {
      label: 'SPRÁVY',
      className: window.location.pathname === '/messages' ? 'active-menu-item' : '',
      command: () => navigate('/messages'),
    },
  ];

  const rightSide = (
    <div className="p-d-flex p-ai-center p-gap-2" style={{ marginRight: '2rem' }}>
      <a href="/change-password" style={{ textDecoration: 'none', color: 'white' }}>
        ZMENA HESLA
      </a>
    </div>
  );

  return (
    <React.Fragment>
      <div className="client-theme">
        <header>
          {/* First row: logo + name/log out (hidden on small screens) */}
          <div
            className="d-flex justify-content-between align-items-center px-3 py-2"
            style={{ marginLeft: '2rem', marginRight: '2rem', marginBottom: '0.5rem', marginTop: '0.5rem' }}
          >
            <div className="logo" onClick={() => navigate('/')}>
              <img src="public/images/logo.png" alt="Logo" style={{ height: '40px' }} />
            </div>
            <div className="d-none d-md-block">
              <span style={{ marginRight: '1rem' }}>
                <a href="/account" style={{ fontWeight: 400 }}>
                  {account.firstName} {account.lastName}
                </a>
              </span>{' '}
              |{' '}
              <span style={{ marginLeft: '1rem' }}>
                <a href="/logout">Odhlásiť</a>
              </span>
            </div>
          </div>
          <div className="d-block d-md-none" style={{ justifySelf: 'center' }}>
            <span style={{ marginRight: '1rem' }}>
              {account.firstName} {account.lastName}
            </span>{' '}
            |{' '}
            <span style={{ marginLeft: '1rem' }}>
              <a href="#">Odhlásiť</a>
            </span>
          </div>

          <div className="client-menu" style={{ backgroundColor: 'var(--primary-color)' }}>
            <Menubar model={menuItems} end={rightSide} style={{ border: 'none', backgroundColor: 'var(--primary-color)' }} />
          </div>
        </header>
        {showBanner && (
          <div
            className="banner-container"
            style={{
              position: 'relative',
              width: '100%',
              maxHeight: '500px', // fixed banner height you want
              overflow: 'hidden', // hide extra part
            }}
          >
            {/* Background image */}
            <img
              src="public/images/pozadie.png" // <-- correct path from /public
              alt="Banner"
              style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top' }}
            />

            {/* Overlay image (top-right) */}
            <img
              src="public/images/nfa.png" // <-- correct path from /public
              alt="Text Overlay"
              style={{
                position: 'absolute',
                top: '10%',
                right: '10%',
                maxWidth: '30%',
                height: 'auto',
                zIndex: 2, // make sure it’s above
                pointerEvents: 'none', // so clicks go through if needed
              }}
            />
          </div>
        )}
        <div className={classNames('layout-container')}>
          <div className="layout-content-wrapper">
            <div className="layout-content">{props.children}</div>
          </div>
          <div className="layout-mask"></div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ClientLayout;
